import blogStyles from 'styles/Blog.module.css';
import styles from 'styles/Guideline.module.css';
import TitleLine from 'assets/images/rulebook/title_line.png';
import { Helmet } from "react-helmet-async";

const Guideline = () => {
  return (
    <>
      <div className={styles["first-view"]}>
        <Helmet>
          <title>ガイドライン | AREA CUP</title>
          <meta property="og:title" content="ガイドライン | AREA CUP" />
          <meta name="twitter:title" content="ガイドライン | AREA CUP" />
        </Helmet>
        <h1 className={styles["guideline-title"]}>GUIDELINE</h1>
        <div className={styles["guideline"]}>
          <h2 className={styles["guideline-text"]}>ガイドライン</h2>
          <img src={TitleLine} className={styles["guideline-image"]} draggable="false" />
          <div className={styles["diamond1"]}></div>
          <div className={styles["diamond2"]}></div>
        </div>
      </div>
      <div className={styles["background"]}>
        <div className={styles["container"]}>
          <div className={blogStyles["markdown"]}>
            <h1>前提</h1>
            <p>
              AREA CUPは、有志のスプラトゥーンユーザーによって運営されています。<br />
              本ガイドラインは、AREA CUPのスタッフ全員の合意に基づいて作成されました。
            </p>

            <p>
              本ガイドラインは、AREA CUPが主催する大会における<br />
              ミラー配信や創造性のあるコンテンツの作成・投稿に適用されます。
            </p>

            <p>
              AREA CUPが主催していない大会や、<br />
              その他のコンテンツに関する配信は対象外です。
            </p>

            <p>
              ガイドラインが遵守されない場合、著作権に関する異議申し立てが行われる可能性があります。
            </p>

            <p>&nbsp;</p>

            <h1>ガイドライン</h1>
            <p>AREA CUPが主催する大会のライブ配信のミラー配信や動画投稿を行う際はこのガイドラインに従ってください。</p>

            <h2>1. ルール</h2>
            <p>ミラー配信を行う方は、ゲームカテゴリーを「スプラトゥーン3」に設定し、配信タイトルに「#AREA CUP」または「#エリア杯」を入れてください。</p>
            <p>AREA CUP運営への報告は任意であり、必須ではありません。</p>

            <p>&nbsp;</p>

            <h2>2. 禁止事項</h2>
            <h3>2.1 誹謗中傷の禁止</h3>
            <p>特定の個人、団体、法人は商標を貶める目的での使用は禁止します。</p>
            <p>また、そのようなコメントやチャットがあった場合は、必ずモデレーションを行ってください。</p>
            <p>&nbsp;</p>
            <h3>2.2 創造性が含まれないアーカイブ・VoD投稿の禁止</h3>
            <p>ミラー配信を行うストリーマーの創造性やコメントが含まれていない無編集アーカイブやカットのみのVoD（切り抜き動画）をYouTubeに投稿することは禁止します。</p>
            <p>これは、本配信や公式VoDと全く同じ動画がYouTube上に投稿されることを防ぐための措置です。</p>

            <p>&nbsp;</p>

            <h2>3. その他</h2>
            <p>
              当大会の取扱うゲームタイトルに関する利用規約や<br />
              ミラー配信を行うサービスの利用規約を遵守してください。<br />
              本ガイドラインは予告なく変更または追記を行う場合があります。
            </p>
            <h3>例:</h3>
            <ul>
              <li>ネットワークサービスにおける任天堂の著作物の利用に関するガイドライン</li>
              <li>YouTube 利用規約</li>
              <li>Twitch サービス利用規約</li>
              <li>X(旧Twitter) サービス利用規約</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Guideline;
